import React from "react";
import { useFormContext } from "react-hook-form";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import { ISlotDetails } from "repoV2/features/CheckoutPages/utils/apis/SessionDetailsApi/SessionDetailsApi.interface";
import { getSelectedSessionDetailsFieldName } from "../../../../SessionDetailsFormGroup.utils";

export const useMultipleSessions = ({
    sessions,
}: {
    sessions: ISlotDetails[];
}) => {
    const { listingUuid, listingType } = useCheckoutBasicDetailsContext();
    const { setValue } = useFormContext();

    React.useEffect(
        () => {
            const fieldName = getSelectedSessionDetailsFieldName({
                listingUuid,
                listingType,
            });
            const selectedSessions = sessions
                .filter(session => !session?.isPast)
                .map(session => session.uuid);
            setValue(fieldName, selectedSessions);
        },
        sessions.map(session => session.uuid)
    );
};
